import { createAsyncThunk } from "@reduxjs/toolkit";
import { type PeopleAvailablePackOverview } from "features/Accounts/PackAssignmentModal/types";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type FetchActionPayload } from "../../../../../interfaces/redux";
import dataService from "../../../../Application/services/dataServices/typedDataService";
import { getPrefix } from "../../../../Application/slices/models";
import { type GetPacksRequest, type PeopleAvailablePacksRequest } from "../../types/requests";

const countHeaderName = process.env.REACT_APP_COUNT_HEADER_NAME as string;
const loadGridItemsCount: any = process.env.REACT_APP_LOAD_ITEMS_COUNT;

export const fetchUserAvailablePacks = createAsyncThunk<
  FetchActionPayload<PeopleAvailablePackOverview>,
  PeopleAvailablePacksRequest
>(
  getPrefix({
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.Packs,
    name: "userAvailablePacks",
  }),
  async (requestData: PeopleAvailablePacksRequest, { signal }) => {
    const request: GetPacksRequest = {
      top: loadGridItemsCount,
      skip: requestData.skip,
      orderBy: requestData.orderBy,
      searchTerm: requestData.searchTerm,
    };

    const { getDataPromise, cancel } = dataService.packs.getUserAvailablePacksWithCancel(requestData.peopleId, request);

    signal.addEventListener("abort", cancel);

    const result = await getDataPromise;
    const recordsCount = Number.parseInt(result.headers[countHeaderName]);

    return {
      items: result.data,
      totalCount: recordsCount,
    };
  },
);
